import axios from 'axios';
import { getIdByUrl } from '../helpers/navigationHelpers/navigationHelpers';

import {
	FETCH_PAGE_FAILED,
	FETCH_PAGE_FULFILLED,
	FETCH_PAGE_PENDING,
	FETCH_PAGE_SETTINGS_FAILED,
	FETCH_PAGE_SETTINGS_FULFILLED,
	FETCH_PAGE_SETTINGS_PENDING,
	SET_INITIAL_DATA_FULFILLED,
	TILE_DECORATION_MOUNTED,
} from '../constants/actions/pageActions';
import { API_BASE_URL } from '../constants/paths/api';
import theme from '../constants/theme';
import sleep from '../helpers/sleep';
import { getCurrentCulture } from '../helpers/url/urlHelpers';

export const setInitialDataFulfilled = data => {
	return {
		type: SET_INITIAL_DATA_FULFILLED,
		payload: {
			data,
		},
	};
};

export const fetchPagePending = () => {
	return {
		type: FETCH_PAGE_PENDING,
		payload: null,
	};
};

export const fetchPageFulfilled = page => {
	return {
		type: FETCH_PAGE_FULFILLED,
		payload: {
			page,
		},
	};
};

export const fetchPageFailed = status => {
	return {
		type: FETCH_PAGE_FAILED,
		payload: {
			status,
		},
	};
};

export const fetchPage = url => {
	return async function (dispatch, getState) {
		const { navigation } = getState().navigationReducer;
		const { pages } = getState().pageReducer;
		const id = getIdByUrl(url, navigation);

		// The reducer holds a memory bank of all previous fetched pages
		// If we already have the page we're navigating to, there's no need to fetch it again
		if (pages[id] !== undefined) {
			// Await the exit transitions of the current route we're on
			// because we are vain and want to watch animations
			await sleep(theme.routeTransitions.exitDuration);
			dispatch(fetchPageFulfilled(pages[id]));
			return;
		}

		dispatch(fetchPagePending());

		try {
			const response = await axios(`${API_BASE_URL}/page/${id}?lang=${getCurrentCulture()}`);
			dispatch(fetchPageFulfilled(response.data));
		} catch (error) {
			dispatch(fetchPageFailed(error.request.status));
		}
	};
};

export const routeLocationUpdated = url => {
	return dispatch => {
		dispatch(fetchPage(url));
	};
};

export const fetchPageSettingsPending = () => {
	return {
		type: FETCH_PAGE_SETTINGS_PENDING,
		payload: null,
	};
};

export const fetchPageSettingsFulfilled = page => {
	return {
		type: FETCH_PAGE_SETTINGS_FULFILLED,
		payload: {
			page,
		},
	};
};

export const fetchPageSettingsFailed = status => {
	return {
		type: FETCH_PAGE_SETTINGS_FAILED,
		payload: {
			status,
		},
	};
};

export const fetchPageSettings = () => {
	return async function (dispatch) {
		dispatch(fetchPageSettingsPending());

		try {
			// TODO: Settings will probably be on another node
			const response = await axios(`${API_BASE_URL}/page/3771`);
			dispatch(fetchPageSettingsFulfilled(response.data));
		} catch (error) {
			dispatch(fetchPageSettingsFailed(error.request.status));
		}
	};
};

export const tileDecorationMounted = () => ({
	type: TILE_DECORATION_MOUNTED,
	payload: null,
});
